import React, {useCallback, useState} from "react";
import {
    AutocompleteInput,
    BooleanInput,
    DateInput,
    ReferenceArrayInput,
    ReferenceInput,
    required,
    Title
} from "react-admin";
import {Card, CardContent, Grid} from "@material-ui/core";
import moment from "moment";
import axiosInstance from "../../api/axios";
import {ReportForm, schoolYears, showErrorNotify, showSuccessNotify, TreeCheckboxInput} from "../../components";

const CreateAttendance = (props) => {
    const [unitIds, setUnitIds] = useState([]);
    const [units, setUnits] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [forceCreate, setForceCreate] = useState(false);
    const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
    const [eventId, setEventId] = useState(null);
    React.useEffect(() => {
        if (schoolYears && schoolYears.length > 0) {
            getUnits(schoolYears[0].id);
        } else {
            getUnits(null);
        }
    }, []);


    const getUnits = (schoolYear) => {
        let url;
        if (schoolYear) {
            url = `/api/units/search/filter?clazzWithParents=false&page=0&size=999&sort=id%2CASC&schoolYear=${schoolYear}`;
        } else {
            url = `/api/units/search/filter?clazzWithParents=false&page=0&size=999&sort=id%2CASC`;
        }
        return axiosInstance.get(url).then(rs => {
            setUnits(rs.data.content)
        }, err => {
            props.showNotification(err.message, 'warning');
        });
    }
    // === Generate API ===
    const generateData = useCallback(() => {
        setIsLoading(true);
        axiosInstance
            .post(
                `/api/attendance/generateAttendanceResult`,
                {
                    fromDate,
                    toDate,
                    forceCreate,
                    eventId,
                    unitIds
                }
            )
            .then(() => {
                setIsLoading(false);
                showSuccessNotify("Tạo dữ liệu thành công");
            })
            .catch(() => {
                setIsLoading(false);
                showErrorNotify("Có lỗi xảy ra. Vui lòng liên hệ quản trị viên!");
            });
    }, [fromDate, toDate, forceCreate, eventId]);

    const validate = useCallback(
        (values) => {
            const errors = {};
            setUnitIds(values.unitIds);
            setForceCreate(values.forceCreate);
            setFromDate(values.fromDate);
            setToDate(values.toDate);
            return errors;
        },
        []
    );

    return (
        <Card>
            <Title title="resources.create-attendance.name"/>
            <CardContent>
                <ReportForm
                    params={{
                        unitIds,
                        isLoading,
                        forceCreate,
                        fromDate,
                        toDate,
                        eventId
                    }}
                    validate={validate}
                    excelReport={generateData}
                    isLoading={isLoading}
                    label={"Tạo dữ liệu"}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput
                                label="resources.common.fromDate"
                                source="fromDate"
                                inputProps={{
                                    max: moment().format("YYYY-MM-DD")
                                }}
                                {...props}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <DateInput
                                label="resources.common.toDate"
                                source="toDate"
                                inputProps={{
                                    max: moment().format("YYYY-MM-DD")
                                }}
                                {...props}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <ReferenceInput
                                source="eventId"
                                reference="events"
                                label="resources.soDiemDanh.eventId"
                                perPage={50}
                                filter={{filterPath: "filterSimple", type: "ATTENDANCE"}}
                                validate={required()}
                                onChange={(e, value) => setEventId(value)}
                            >
                                <AutocompleteInput
                                    fullWidth
                                    optionText={(e) => `${e.name} - ${e.eventTime}`}
                                />
                            </ReferenceInput>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <BooleanInput source="forceCreate" label="Tạo lại" {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label>Danh sách lớp</label>
                            <ReferenceArrayInput source="unitIds" reference="baseUnits"
                                                 filter={{
                                                     schoolYearId: schoolYears.length > 0 ? schoolYears[0].id : '',
                                                     clazzOnly: true
                                                 }}
                                                 perPage={999} {...props}
                                                 label='Lớp'
                            >
                                <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                            </ReferenceArrayInput>
                        </Grid>
                        <Grid item xs={12}>
                            <p style={{color: "red", fontSize: 12, fontStyle: "italic"}}>
                                * Lưu ý: nếu chọn Tạo lại dữ liệu sẽ được xoá và tạo lại,
                                cần thực hiện duyệt lại sự kiện nếu có nhu cầu
                            </p>
                            <p style={{color: "red", fontSize: 12, fontStyle: "italic"}}>
                                * Nếu không chọn tạo lại dữ liệu sẽ chỉ cập nhật những lớp/phòng
                                ban chưa được duyệt
                            </p>
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    );
};

export default CreateAttendance;
